<template>
  <QDialog v-model="isOpen" @hide="afterLeave">
    <QCard>
      <div class="modal">
        <div class="modal__header">
          <h2 class="modal__title">Смена пароля</h2>
          <iconClose class="link gray-btn" @click="close()" />
        </div>

        <PreloaderComponent v-if="state.preloader" />
        <div class="modal__field narrow">
          <label class="modal__label">Пароль</label>
          <QInput
            outlined
            v-model="form.data.password"
            type="password"
            class="home__key-input"
          ></QInput>
        </div>
        <div class="modal__field narrow">
          <label class="modal__label">Подтвердите пароль</label>
          <QInput
            outlined
            v-model="form.data.repeatPassword"
            type="password"
            class="home__key-input"
          ></QInput>
        </div>
        <div class="modal__field">
          <div class="column">
            <button
              class="btn btn-primary"
              :disabled="!isFormValid || state.preloader"
              @click="submitNewPassword"
            >
              Подтвердить
            </button>
          </div>
        </div>
      </div>
    </QCard>
  </QDialog>
</template>

<script lang="ts">
interface IState {
  preloader: boolean;
}

interface IInitData {
  password: string;
  repeatPassword: string;
}

interface IForm {
  data: IInitData;
}

const initData = () => ({
  password: '',
  repeatPassword: '',
});

import { defineComponent, ref, reactive, computed, inject } from 'vue';
import { useRouter, Router } from 'vue-router';
import iconClose from '@/components/icons/iconClose.vue';
import { QDialog, QCard, QInput, QCheckbox } from 'quasar';
import { useAuthStore } from '@/store/authStore';
import { changePassword } from '@/api/authService';
import { showError } from '@/utils/errorsInterceptor';
import PreloaderComponent from '@/components/shared/PreloaderComponent.vue';
import PreloaderBlock from '@/components/shared/PreloaderBlock.vue';

export default defineComponent({
  name: 'ChangeEmailModal',
  components: {
    iconClose,
    QDialog,
    QCard,
    QInput,
    QCheckbox,
    PreloaderComponent,
    PreloaderBlock,
  },
  emits: ['close', 'reset', 'openRegistration', 'resetPass'],
  props: {},

  setup(props, { emit }) {
    const axios: any = inject('axios');
    const store = useAuthStore();
    const router: Router = useRouter();
    const isOpen = ref(false);
    const state: IState = reactive({
      preloader: false,
    });
    const form: IForm = reactive({
      data: initData(),
    });

    const isFormValid = computed((): boolean => {
      return Boolean(form.data.password && form.data.repeatPassword);
    });

    const submitNewPassword = async (): Promise<void> => {
      const params = {
        password: form.data.password,
      };
      state.preloader = true;
      try {
        const response = await changePassword(params);
        state.preloader = false;
        if (response && response.data) {
          close();
        }
      } catch (error) {
        state.preloader = false;
        showError(error);
      }
    };

    const openRegistration = (): void => {
      close();
      emit('openRegistration');
    };

    const resetPass = (): void => {
      close();
      emit('resetPass');
    };

    const close = (): void => {
      form.data = initData();
      isOpen.value = false;
      emit('reset');
    };

    const afterLeave = () => {
      form.data = initData();
      emit('close');
    };

    const reset = (): void => {
      form.data = initData();
      emit('reset');
    };

    return {
      isOpen,
      submitNewPassword,
      close,
      afterLeave,
      reset,
      resetPass,
      form,
      state,
      openRegistration,
      isFormValid,
    };
  },
});
</script>

<style lang="scss" scoped>
.modal {
  max-width: 480px;
  padding: 48px;
  display: flex;
  flex-direction: column;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__title {
    font-weight: 700;
    font-size: 23px;
    line-height: 28px;
    letter-spacing: 1px;
  }
  &__field {
    position: relative;
    margin-top: 24px;
    min-width: 384px;
  }
  &__field-error {
    position: absolute;
    bottom: -19px;
    font-size: 12px;
    color: var(--typography-error);
  }
  &__stay-loggined {
    display: flex;
    justify-content: space-between;
    margin-left: -8px;
    align-items: center;
  }
  &__no-accaunt {
    margin: 16px auto 0px auto;
  }
}
</style>
